'use strict';

angular.module('app')
  .controller('MyBookings', function ($scope, $routeParams, info, paymentService, typeURL, Booking, Request, utils, DiveOperator, checkoutDrService, checkoutService, $filter, $rootScope, gettextCatalog, $uibModal, diviacLocalStorage) {
    var vm = this,
      prevSlug;

    $scope.operator = {itineraryInfo: {}};

    vm.activePage = 1;
    vm.pastPage = 1;
    vm.current = typeURL;
    vm.setItinerary = setItinerary;
    vm.setCabin = setCabin;
    vm.getMoreReviews = getMoreReviews;
    vm.getPaymentData = getPaymentData;
    vm.getOrderData = getOrderData;
    vm.statusColor = statusColor;
    vm.nextPage = nextPage;
    vm.generateLink = Booking.generateLink;
    vm.showItemPrice = showItemPrice;
    vm.setTransferIcon = utils.setTransferIcon;
    vm.updateNewIclusions = updateNewIclusions;
    vm.newIclusions = {};
    vm.updateOrder = updateOrder;
    vm.isAddItemsActive = false;
    vm.resetOrder = resetOrder;
    vm.setLimit = checkoutDrService.setLimit;
    vm.saveOnLeave = saveOnLeave;
    vm.cardFormVisible = false;
    vm.paymentCompleteCallback = paymentCompleteCallback;
    vm.parsePaymentMethod = parsePaymentMethod;
    vm.unconfirmedOrder = false;
    // vm.paymentProcessor = utils.makeABTest() ? paymentService.STRIPE_PP : paymentService.ADYEN_PP;
    // vm.paymentProcessor = 10;
    vm.paymentProcessor = diviacLocalStorage.get('paymentProcessor') || paymentService.STRIPE_PP;

    getOrderData($routeParams.id);

    function setItinerary(obj) {
      return Request.get('shop/' + obj.shopLocationSlug + '/' + obj.shopSlug + '/itineraries/' + obj.itinerarySlug + '/').then(function (res) {
        vm.itinerary = res.data;
        vm.itinerary.loading = false;
        vm.itinerary.days = utils.bindItinerary(vm.itinerary.days);

        utils.bindLogistic(vm.itinerary.descriptions);

        return res.data;
      });
    }

    function setCabin(id) {
      if (vm.cabin && vm.cabin.id === id) {
        return true;
      }

      Booking.cabinDetails(id).then(function (data) {
        vm.cabin = data;
      });
    }

    function getMoreReviews(order, firstLoad) {
      vm.reviewsLoading = true;

      if (prevSlug && order && prevSlug !== order.shopSlug) {
        vm.allReviews = [];
        vm.reviews = null;
      }

      if (order) {
        prevSlug = order.shopSlug;
      }

      DiveOperator.reviews('liveaboard', firstLoad ? null : vm.reviews.data.next, prevSlug).then(function (rating) {
        vm.reviews = rating;

        _.map(rating.data.results, function (val) {
          vm.allReviews.push(val);
        });

        vm.reviews.data.results = vm.allReviews;
        vm.reviewsLoading = false;
      });
    }

    function getPaymentData(order) {
      Booking.getPrices(order.id).then(function (data) {
        vm.pricing = data;
        vm.pricing.kind = order.shopKind;
      });
    }

    function getOrderData(id) {
      vm.loader = true;

      Booking.getOrder(id).then(function (data) {
        vm.order = data;
        vm.diversNumber = 0;
        vm.nonDiversNumber = 0;
        vm.studentsNumber = 0;
        parsePaymentMethod(vm.order.paymentMethod); // standartize payment info for old orders
        if (!vm.order.isPast && (vm.order.status === 20 || vm.order.status === 130 || vm.order.status === 90)) {
          // check if order already have payment processor
          if (vm.order.paymentProcessor) {
            vm.paymentProcessor = vm.order.paymentProcessor;
          }

          if (vm.paymentProcessor === paymentService.STRIPE_PP) {
            paymentService.initStripe();
          } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
            paymentService.initAdyen();
          }
          vm.paymentEditAllowed = true;
        } else if (!vm.order.isPast && (vm.order.status === 10 || vm.order.status === 110)) {
          vm.unconfirmedOrder = true;
        }

        vm.groupedRooms = _(data.orderDetails.accomodation)
          .each(function (val) {
            val.occupancy = val.divers + val.nonDivers + val.students;
            vm.diversNumber += val.divers;
            vm.studentsNumber += val.students;
            vm.nonDiversNumber += val.nonDivers;
          })
          .groupBy('occupancy')
          .value();

        vm.groupedByDivesNumber = _(vm.order.dives)
          .sortByOrder('numberOfInstances')
          .groupBy('numberOfInstances')
          .value();

        vm.cancellation = {
          policy: data.cancellationPolicy,
          isCustomCancellation: data.isCustomCancellation,
          customCancellationText: data.customCancellationText,
          milestones: data.cancellationMilestones,
          policyText: _.find(info.shop.CANCELLATION_POLICY, function (val) {
            return val[0] === data.cancellationPolicy;
          }),
          qty: 1,
          onlyDP: function () {
            return data.isDiveProductsOnly;
          },
        };

        vm.ccFormButtonText = vm.order.status === 90 ? gettextCatalog.getString('Convert option to booking') : '';

        // check if there is some items not included and payed on site
        // to display hint under price panels
        vm.order.itemsExtraLegend = false;
        vm.order.itemsMandatoryLegend = false;
        _.each(vm.order.itemsMandatory, function (item) {
          if (!item.payedInAdvance) vm.order.itemsMandatoryLegend = true;
        });

        _.each(vm.order.itemsExtra, function (item) {
          if (!item.payedInAdvance) vm.order.itemsExtraLegend = true;
        });

        if (data.shopKind === 10) {
          setItinerary(data).then(function (itinerary) {
            vm.itinerary = itinerary;
            vm.logistics = itinerary.logistics;
            vm.descriptions = itinerary.descriptions;
            vm.useNewLogisticsData = itinerary.useNewLogisticsData;

            vm.whatsIncluded = itinerary.whatsIncluded;
            vm.whatsNotIncluded = itinerary.whatsNotIncluded;
            vm.whatsIncludedNew = itinerary.whatsIncludedNew;
            vm.mandatoryInAdvance = itinerary.mandatoryInAdvance;
            vm.mandatoryOnBoard = itinerary.mandatoryOnBoard;
            vm.optionalInAdvance = itinerary.optionalInAdvance;
            vm.optionalBookableAdvancePaidOnBoard = itinerary.optionalBookableAdvancePaidOnBoard;
            vm.optionalOnBoard = itinerary.optionalOnBoard;
            vm.notIncludedInfo = itinerary.notIncludedInfo;
            vm.isNewModelUsed = itinerary.isNewModelUsed;
          });

          Booking.getPrices(id).then(function (prices) {
            vm.order.totalCabinPrices = 0;

            _.each(vm.order.cabinOverview, function (val) {
              vm.order.totalCabinPrices += val.cabinSubtotal;
            });

            vm.order.taxes = prices.taxes;
            vm.loader = false;
          }).catch(function () {
            vm.loader = false;

            $rootScope.showNotify(gettextCatalog.getString('Something went wrong'), 5000);
          });
        } else {
          vm.loader = false;
        }

        var orderDates = { date_0: moment(vm.order.dateFrom).format('YYYY-MM-DD'), date_1: moment(vm.order.dateTo).format('YYYY-MM-DD'), slug: vm.order.shopSlug };

        // getting inclusions
        if (vm.order.shopKind !== 10) {
          checkoutDrService.getInclusions(orderDates,
            {
              divers: vm.diversNumber,
              students: vm.studentsNumber,
              nonDivers: vm.nonDiversNumber,
              duration: vm.order.duration,
              rooms: vm.order.rooms.quantity,
              numberOfDives: vm.order.divesInfo.totalDives,
            })
            .then(function (data) {
              vm.inclusions = data.groupedInclusions;

              vm.groupedInclusions = {};

              vm.sectionWithoutMandatory = {};

              _.each(vm.inclusions, function (val, key) {
                vm.sectionWithoutMandatory[key] = _.filter(val, function (v) {
                  return !v.isMandatory && !v.isIncluded && v.isBookableInAdvance && !v.payedInAdvance;
                });

                if (vm.rentalEquipmentId !== +key && vm.dcExtrasId !== +key) {
                  var belongsToObject = _.find(info.inclusionGroups, { id: +key });

                  if (belongsToObject) {
                    vm.groupedInclusions[key] =  {
                      title: belongsToObject.title,
                      order: belongsToObject.order,
                      isTransfer: belongsToObject.unique_identifier === 'Transfers',
                      key: key,
                      data: val,
                    };
                  }
                }
              });
            });

          checkoutService.getInsurances().then(function (data) {
            vm.order.extrasInsurances = data;
            vm.paidInsurances = false;
            _.each(vm.order.extrasInsurances, function (insurance) {
              insurance.isFree = $rootScope.setValue(vm.order.totalPackagePrice / vm.order.pax, vm.order.currency, true, insurance.limitPriceCurrency) > +insurance.limitPrice;
              insurance.isInsurance = true;
              if (!insurance.isFree) {
                // show insurance only if its free;
                insurance.qty = 0;
                vm.paidInsurances = true;
              }
            });
          });
          
          if (vm.order.isDynamicPackages === false) {
            vm.order.packageDiveKind = _.get(vm.order.dives, '[0].packageDivesKind', vm.order.diveType);
          }
          vm.order.diveTypeName = utils.getTextFromInfo(vm.order.diveType, 'shop', 'DIVE_TYPE').toLowerCase();
        }
      });
    }

    function nextPage(page, isPast) {
      vm.loader = true;

      Booking.getList({page: page, is_past: isPast}).then(function (data) {
        vm[isPast ? 'pastBookings' : 'activeBookings'] = data.results;
        vm.loader = false;
      });
    }

    function statusColor(status) {
      var colorClass;

      if ([10, 90, 110].indexOf(status) !== -1) {
        // INACTIVE
        colorClass = 'inactive';
      } else if ([30, 40, 50, 60, 70, 80].indexOf(status) !== -1) {
        // CANCELLED
        colorClass = 'cancelled';
      } else if (status === 100 || status === 20) {
        // COMPLETED
        colorClass = 'completed';
      }
      return colorClass;
    }

    // Edit or add credit card

    vm.paymentEditAllowed = false;
    // vm.updateCard = updateCard;

    // function updateCard(form) {
    //   form.$submitted = true;

    //   if (form.$valid) {
    //     var order = _.clone(vm.order);

    //     vm.loader = true;

    //     paymentService.createSource(function (response) {
    //       var displayError = document.getElementById('stripe-errors');

    //       if (response.error) {
    //         $scope.$apply(function () {
    //           vm.loader = false;
    //         });

    //         displayError.innerHTML = '&#10006; ' + response.error.message;

    //         return false;
    //       }
    //       if (displayError) displayError.innerHTML = '';
    //       order.stripeSourceId = response.source ? response.source.id : null;
    //       // order.token = response.token.id;
    //       // order.cardLast4 = response.token.card.last4;
    //       // order.cardBrand = response.token.card.brand || response.token.card.paymentMethod;
    //       // order.card_country = response.token.card.country;
    //       order.paymentProcessor = 10;

    //       checkoutService.updateCard(order).then(function (data) {
    //         vm.order.cardBrand = data.cardBrand;
    //         vm.order.cardLast4 = data.cardLast4;
    //         $rootScope.showNotify(gettextCatalog.getString('your credit card was successfully updated'), 5000);
    //       }).catch(function (error) {
    //         if (error.status === 500) {
    //           return $rootScope.showNotify(gettextCatalog.getString('Something went wrong!'));
    //         }

    //         if (error.data) {
    //           $rootScope.showNotify(_.map(error.data)[0], 5000);
    //         }
    //       }).finally(function () {
    //         vm.loader = false;
    //       });
    //       return true;
    //     });
    //   }
    // }

    function showItemPrice(pricing, qty) {
      var price = pricing.priceGross;

      if (pricing.payedInAdvance === false && !price) {
        return pricing.extraValue;
      }

      return $rootScope.setValue((qty || 1) * price, pricing.currency || vm.order.currency, 0, 0, 0, true);
    }

    function updateNewIclusions(inclusion) {
      if ( (inclusion.isIncluded || inclusion.isMandatory || !inclusion.isBookableInAdvance || inclusion.payedInAdvance) && !inclusion.isInsurance) {
        return false;
      }

      if (inclusion.isInsurance) {
        inclusion.pricingId = inclusion.prices[0].id;
      }

      if (vm.newIclusions[inclusion.pricingId] && inclusion.qty === 0) {
        delete vm.newIclusions[inclusion.pricingId];
      } else if (inclusion.qty !== 0) {
        vm.newIclusions[inclusion.pricingId] = inclusion.qty;
      }

      vm.isAddItemsActive = !_.isEmpty(vm.newIclusions);
    }

    function updateOrder() {
      var patchData = {
        'items': [],
      };
      _.each(vm.newIclusions, function (qty, pricingID) {
        if (qty > 0) {
          patchData.items.push({
            pricing: pricingID,
            quantity: qty,
          });
        }
      });

      if (patchData.items.length) {
        vm.loader = true;

        Booking.updateOrder(vm.order.uuid, patchData).then(function () {
          getOrderData(vm.order.uuid);
          $rootScope.showNotify(gettextCatalog.getString('successfully added to your order'), 5000);
        }).catch(function (res) {
          if (res.data.nonFieldErrors) {
            $rootScope.showNotify(res.data.nonFieldErrors, 4000);
          }
        }).finally(function () {
          vm.loader = false;
          resetInclusions();
        });
      }
    }

    function resetInclusions() {
      vm.newIclusions = {};
      vm.isAddItemsActive = false;
      _.each(vm.groupedInclusions, function (group) {
        _.each(group.data, function (incl) {
          incl.qty = 0;
        });
      });
    }

    function resetOrder() {
      if (vm.isAddItemsActive) {
        saveOnLeave();
      } else {
        vm.order = false;
        vm.newIclusions = {};
        vm.paymentEditAllowed = false;
        paymentService.cardDestroy();
      }
    }

    function saveOnLeave() {
      var modalInstance = $uibModal.open({
        animation: false,
        templateUrl: '../templates/_save_on_leave.html',
        controller: function ($scope, $uibModalInstance) {
          var vm = this;

          vm.continue = function () {
            $uibModalInstance.close(1);
          };

          vm.cancel = function () {
            $uibModalInstance.dismiss(2);
          };
        },
        controllerAs: 'ctrl',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'save-on-leave',
        scope: $scope,
      });

      return modalInstance.result.then(function (res) {
        updateOrder();
      }, function (err) {
        vm.isAddItemsActive = false;
        resetOrder();
      });
    }

    function paymentCompleteCallback(response) {
      vm.loader = true;
      var order = _.clone(vm.order),
        errorMessage = $('.error-msg');

      if (response.error || response.errorCode) {
        vm.loader = false;
        errorMessage.text(response.error.message);
        errorMessage.addClass('visible');
        return false;
      }

      if (vm.paymentProcessor === paymentService.STRIPE_PP) {
        order.stripeSourceId = response.source ? response.source.id : undefined;
      } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
        order.adyenPaymentData = response;
      }
      order.paymentProcessor = vm.paymentProcessor;

      paymentService.updatePaymentMethod(order).then(function (data) {
        // vm.order.cardBrand = data.cardBrand;
        // vm.order.cardLast4 = data.cardLast4;
        // vm.paymentEditAllowed = false;
        angular.extend(vm.order, data);
        if (order.status === 90) {
          Booking.confirmBooking(vm.order.uuid).then(function () {
            $rootScope.showNotify(gettextCatalog.getString('Your option request converted to booking'), 5000);
            vm.order.status = 20;
            vm.loader = false;
          });
        } else {
          vm.loader = false;
          $rootScope.showNotify(gettextCatalog.getString('Your payment method was successfully updated'), 5000);
        }
        // update order info;
        getOrderData(vm.order.uuid);
      }).catch(function (error) {
        vm.success = false;
        if (error.status === 500) {
          return $rootScope.showNotify(gettextCatalog.getString('Something went wrong!'));
        }
        if (error.data) {
          $rootScope.showNotify(_.map(error.data)[0], 5000);
          errorMessage.text(_.map(error.data)[0]);
          errorMessage.addClass('visible');
        }
        vm.loader = false;
        return false;
      }).finally(function () {
        return true;
      });
      return true;
    }

    function parsePaymentMethod(paymentMethod) {
      if (paymentMethod) {
        if (paymentMethod.brand && paymentMethod.last4) {
          // old orders
          paymentMethod.card = {};
          paymentMethod.card.brand = paymentMethod.brand;
          paymentMethod.card.last4 = paymentMethod.last4;
        }
      }
      console.log(vm.order.paymentMethod);
    }
  });
